import VerifyComponent from './VerifyContainer';

export default VerifyComponent;
